// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.margin_transaction_header_row_box{
  display: flex;
  flex-direction: row;
  justify-content: start;
  gap: 25px;
  width: max-content;
  background-color: var(--bg-card);
  padding: 0 25px;
  border-radius: 12px;
  width: 80%;
  border: 1px solid var(--border);
  box-shadow: var(--shadow-sm);
}

.margin_transaction_header_column_box{
  display: flex;
  flex-direction: column;
  padding: 25px 0;
}

.margin_transaction_header_column_title{
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 5px;
}

.margin_transaction_header_column_content{
  font-size: 16px;
  font-weight: 400;
  color: var(--text-primary);
}



.margin_transaction_details_item_title {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  display: block;
  color: var(--text-muted);
}

.margin_transaction_details_box {
  width: 80%;
  display: flex;
  flex-direction: column;
  background-color: var(--bg-card);
  padding: 20px;
  border-radius: 15px;
  border: 1px solid var(--border);
  box-shadow: var(--shadow-sm);
}

.margin_transaction_details_row_box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
}

.margin_transaction_details_title {
  margin: 0 0 20px 0;
  font-size: 22px;
  font-weight: bold;
}

.margin_transaction_details_column_box{
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.margin_transaction_details_p {
  margin: 5px 0;
}

.withdrawDepositById_details_item_title {
  margin: 0;
  font-size: 11px;
  display: block;
  color: var(--text-muted);
}

.withdrawDepositById_details_item_desc{
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: var(--text-secondary);
}`, "",{"version":3,"sources":["webpack://./src/pages/finances/subpages/MarginTransactions/MarginTransactionById/marginTransactionById.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,mBAAmB;EACnB,UAAU;EACV,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;;;AAIA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B","sourcesContent":[".margin_transaction_header_row_box{\n  display: flex;\n  flex-direction: row;\n  justify-content: start;\n  gap: 25px;\n  width: max-content;\n  background-color: var(--bg-card);\n  padding: 0 25px;\n  border-radius: 12px;\n  width: 80%;\n  border: 1px solid var(--border);\n  box-shadow: var(--shadow-sm);\n}\n\n.margin_transaction_header_column_box{\n  display: flex;\n  flex-direction: column;\n  padding: 25px 0;\n}\n\n.margin_transaction_header_column_title{\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: 5px;\n}\n\n.margin_transaction_header_column_content{\n  font-size: 16px;\n  font-weight: 400;\n  color: var(--text-primary);\n}\n\n\n\n.margin_transaction_details_item_title {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 700;\n  display: block;\n  color: var(--text-muted);\n}\n\n.margin_transaction_details_box {\n  width: 80%;\n  display: flex;\n  flex-direction: column;\n  background-color: var(--bg-card);\n  padding: 20px;\n  border-radius: 15px;\n  border: 1px solid var(--border);\n  box-shadow: var(--shadow-sm);\n}\n\n.margin_transaction_details_row_box {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  gap: 20px;\n}\n\n.margin_transaction_details_title {\n  margin: 0 0 20px 0;\n  font-size: 22px;\n  font-weight: bold;\n}\n\n.margin_transaction_details_column_box{\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n}\n\n.margin_transaction_details_p {\n  margin: 5px 0;\n}\n\n.withdrawDepositById_details_item_title {\n  margin: 0;\n  font-size: 11px;\n  display: block;\n  color: var(--text-muted);\n}\n\n.withdrawDepositById_details_item_desc{\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-secondary);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
